import React from "react";
import { useTranslation } from "react-i18next";
import { Grid } from "@vds/grids";
import { Text } from '@vds/core';
import ByodPackageImage from "../ByodPackageImage/ByodPackageImage";
import { MarginSpacerL, MarginSpacerM, MarginSpacerS } from "common/components/styleTag";
import {
  LeftImageSectionNew,
  DeviceInfoContainerNew,
  ColNoPad,
  RowNoPad,
  RightSectionNew,
} from "./styles";
import { useSelector } from "react-redux";
import { TitleLockup, TitleLockupTitle, TitleLockupSubtitle, TitleLockupEyebrow } from "@vds/core";
import { Icon } from "@vds/icons";
import styled from "styled-components";
import { Button } from "@vds/buttons";

const StyledColIcon = styled.div`
  display: flex;
  flex-direction: row;
  margin-top: 10px;
`;

const SelectedDeviceMonarch = ({
  deviceInfo,
  currentDevice,
  selectedDevice,
  selectedCarrier,
  inputValue,
  isOldSim,
  isESIM,
  device,
  isVZNumber = "",
  selectedFeature,
  deviceName,
  sno,
  comp1,
  onCheckAvailability=()=>{},
  isMobile
}) => {
  const { t } = useTranslation(["byod"]);
  const globalData = useSelector((state) => state.GlobalData);
  const agentLinkFlowType = globalData?.agentLinkFlowType;
  const ByodDeviceName = t("byod.deviceDescription.deviceAgentLinkSno", {
    ns: "byod",
    sno: sno,
    deviceName: agentLinkFlowType === 'laptops' ? "Laptop" : "Tablet"
  });
  const aemContentMonarch = t("byodMonarch.deviceTile", { ns: "byod", returnObjects: true });

  return (
    <>
      <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between" }}>
        <LeftImageSectionNew>
          <div>
            <ByodPackageImage
              device={deviceInfo}
              description={{}}
              deviceList={currentDevice}
              width={72}
              height={72}
            />
          </div>
          <DeviceInfoContainerNew>
            <div>
              <TitleLockup>
                <TitleLockupEyebrow size="bodyLarge" >{t("byod.deviceDescription.deviceSno", {
                  ns: "byod",
                  sno: sno,
                })}</TitleLockupEyebrow>
                <TitleLockupTitle bold size="titleXSmall" >
                  {device?.deviceInfo?.imei && device?.imei
                    ? device?.deviceInfo?.brand ? `${device?.deviceInfo?.brand}`
                      : `${device?.deviceInfo?.productName}`
                    : selectedDevice?.make && selectedDevice?.modelName
                      ? `${selectedDevice?.make} ${selectedDevice?.modelName}`
                      : globalData?.fromAgentLinkDealsPage ? ByodDeviceName : `${selectedDevice?.modelName}`}
                </TitleLockupTitle>
                {device?.deviceInfo?.imei && device?.imei && <TitleLockupSubtitle size="bodyLarge" > {aemContentMonarch?.imeiLabelTop}
                  {device?.deviceInfo?.imei}
                </TitleLockupSubtitle>}
                {selectedCarrier && device?.deviceInfo?.imei && <MarginSpacerS />}
                {selectedCarrier && <TitleLockupSubtitle size="bodyLarge">
                  {aemContentMonarch?.carrier}  {selectedCarrier}
                </TitleLockupSubtitle>}
                <MarginSpacerS />
                {device?.isByor ? <StyledColIcon>
                  {device?.imei && <Icon name="alternate-checkmark" size="medium" color="#004B1C" />}
                  {device?.deviceInfo && device?.isByor && <Text kind="body" color="#004B1C" size="medium">{aemContentMonarch?.byorContent?.compatible}</Text>}
                </StyledColIcon> :
                  <TitleLockupSubtitle size="bodyLarge">
                    {aemContentMonarch?.simType} {isOldSim ? aemContentMonarch?.eSIMLabel : (isESIM || currentDevice?.selectedOpt === "old") ? aemContentMonarch?.eSIMLabel : aemContentMonarch?.pSIMLabel}  {isVZNumber === "No"
                      ? t("byod.skipImei.newPhoneNumber", { ns: "byod" })
                      : t("byod.skipImei.existingPhoneNumber", { ns: "byod" })}
                  </TitleLockupSubtitle>}
                <MarginSpacerS />
                {!!selectedFeature && <TitleLockupSubtitle size="bodyLarge" > {aemContentMonarch?.deviceProtection}
                  {selectedFeature?.displayName}
                </TitleLockupSubtitle>}
              </TitleLockup>
            </div>
            
            {globalData?.fromAgentLinkDealsPage && globalData?.isSkipImeiFlow ?
              <>
                <MarginSpacerM />
                <Text kind="body" size="small" color="#6F7171">
                  {t("byod.byod-collection.completedTile.deviceLabelCredit", {
                    ns: "byod",
                  })}
                </Text>
                {t("byod.byod-collection.completedTile.noDeviceId", {
                  ns: "byod",
                })}
              </>
              :
              <></>}
          </DeviceInfoContainerNew>

        </LeftImageSectionNew>
        <RightSectionNew>
          {comp1()}
        </RightSectionNew>
        
      </div>
      <div>
        {device?.isByor && (
              <>
                <MarginSpacerL />
                <TitleLockup >
                  <TitleLockupTitle size="titleSmall" bold={true}>
                    {aemContentMonarch?.byorContent?.title}
                  </TitleLockupTitle>
                  <MarginSpacerS />
                  <Text kind="body" size="large">
                    {aemContentMonarch?.byorContent?.subTitle}
                  </Text>
                </TitleLockup>

                <MarginSpacerL />

                <div>
                  <Button
                    disabled={false}
                    onClick={onCheckAvailability}
                    size="large"
                    surface="light"
                    use="primary"
                    width={`${isMobile ? '100%' : 'auto'}`}
                    data-track="Body | Button | Check availability"
                  >
                    {aemContentMonarch?.byorContent?.checkAvailability}
                  </Button>
                </div>
              </>
            )}
      </div>
    </>
  );
};

export default SelectedDeviceMonarch;
